import * as React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import CustomModal from 'src/components/containers/CustomModal'
import { FuneralHome } from 'src/resources'
import {
  ConfiguratorBox,
  VerticalAlignWrapper
} from 'src/components/containers/configurator/ConfiguratorBox'
// import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
import { ConfiguratorText } from 'src/components/atoms/configurator'
import { StoreProps } from 'src/stores'
import { media } from 'src/utils.js'
import { Sharing } from './Sharing'
import Link from '../../atoms/input/buttons/Link'
import ReactHtmlParser from 'react-html-parser'

type Props = StoreProps

interface State {
  fhModalOpen: boolean
  sharingModalOpen: boolean
}

@inject('confStore')
@observer
export default class ClientDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      fhModalOpen: false,
      sharingModalOpen: false
    }
  }

  toggleFHModal = () => {
    const { fhModalOpen } = this.state
    this.setState({ fhModalOpen: !fhModalOpen })
  }

  toggleSharingModal = () => {
    const { sharingModalOpen } = this.state
    this.setState({ sharingModalOpen: !sharingModalOpen })
  }

  planningReasonName = (planningReason) => {
    switch (planningReason) {
      case 'ACUTE_BEREAVEMENT':
        return 'Eingetretener Trauerfall'
      case 'IMPENDING_BEREAVEMENT':
        return 'Bevorstehender Trauerfall'
      case 'PROVISION':
        return 'Bestattungsvorsorge'
      default:
        return 'Ungültig!'
    }
  }

  contactDetails = () => {
    const { confStore } = this.props
    const offer = confStore.getOffer
    return (
      <>
        {offer.contactDetails.greeting ? (
          <DetailLine>
            {' '}
            {offer.contactDetails.greeting === 'MRS' ? 'Frau' : 'Herr'}{' '}
          </DetailLine>
        ) : (
          ''
        )}
        <DetailLine>
          <span id='contactName'>{offer.contactDetails.firstName} {offer.contactDetails.lastName}</span>
        </DetailLine>
        <DetailLine>E: <span id='contactEmail'>{offer.contactDetails.email}</span></DetailLine>
        {offer.contactDetails.phone ?
          <DetailLine>{'T: '}<span id='contactPhone'>{offer.contactDetails.phone}</span></DetailLine> : ''}
      </>
    )
  }

  enterContactDetailsClaim = () => {
    const { confStore } = this.props
    return (
      <>
        <ConfiguratorText>Fügen Sie Ihre Kontaktdaten</ConfiguratorText>
        <ConfiguratorText>hinzu und vervollständigen</ConfiguratorText>
        <ConfiguratorText>Sie Ihre Planung.</ConfiguratorText>
        <VerticalAlignWrapper>
          <Link light onClick={() => confStore.setContactDetailsPopup(true)}>
            Kontakt hinzufügen
          </Link>
        </VerticalAlignWrapper>
      </>
    )
  }

  render() {
    const { confStore } = this.props
    const { fhModalOpen, sharingModalOpen } = this.state
    const offer = confStore.getOffer
    const funeralHome = confStore.getCatalogue.funeralHome

    return (
      <ConfiguratorBox
        title='Ihr Angebot'
        style={{ gridArea: 'info', marginBottom: '15px' }}
        hideOnMobile
        actionIcon='fa-share-alt'
        actionIconOnClick={this.toggleSharingModal}>
        <FuneralHomeModal
          open={fhModalOpen}
          onClose={this.toggleFHModal}
          funeralHome={funeralHome}
        />
        <Sharing open={sharingModalOpen} onClose={this.toggleSharingModal} />
        <DetailContainer>
          <ContactDetailsContainer>
            <DetailBoxHeader>
              <VerticalAlignWrapper>
                <p>Kundendaten</p>
              </VerticalAlignWrapper>
            </DetailBoxHeader>
            {offer.contactDetails.firstName === ''
              ? this.enterContactDetailsClaim()
              : this.contactDetails()}
          </ContactDetailsContainer>

          <div>
            <DetailBoxHeader>
              <p>Angebotsdetails</p>
            </DetailBoxHeader>
            <ConfiguratorText>
              {this.planningReasonName(offer.planningReason)}
            </ConfiguratorText>
            <ConfiguratorText>Angebot: {offer.orderId}</ConfiguratorText>
            <ConfiguratorText>Datum: {offer.creationDate}</ConfiguratorText>
            <ConfiguratorText>
              Ort:{' '}
              {offer.location.label
                ? offer.location.label
                : offer.location.city}
            </ConfiguratorText>
          </div>

          <div>
            <DetailBoxHeader>
              <p>Ansprechpartner</p>
            </DetailBoxHeader>
            <ConfiguratorText>
              {offer.customerAgent != null && offer.customerAgent.name != null
                ? offer.customerAgent.name
                : 'Benu Kundenbetreuung'}
            </ConfiguratorText>
            <ConfiguratorText>
              T: <a href='tel:+4319076885'>01 907 68 85</a>
            </ConfiguratorText>
            <ConfiguratorText>
              E: <a href='mailto:kontakt@benu.at'>kontakt@benu.at</a>
            </ConfiguratorText>
            <ConfiguratorText />
          </div>
        </DetailContainer>
        {/*<FuneralHomeInfo show={!!funeralHome}>*/}
        {/*  <p>Unser Partner vor Ort:</p>*/}
        {/*  <FuneralHomeName onClick={this.toggleFHModal}>*/}
        {/*    {!!funeralHome && <p>{funeralHome.name}</p>}*/}
        {/*    <InlineInfoIcon />*/}
        {/*  </FuneralHomeName>*/}
        {/*</FuneralHomeInfo>*/}
      </ConfiguratorBox>
    )
  }
}

interface FHProps {
  funeralHome: FuneralHome
  open: boolean
  onClose: () => void
}
const FuneralHomeModal = (props: FHProps) => {
  const { open, onClose, funeralHome } = props
  if (!funeralHome) return null
  return (
    <CustomModal title='Unser Partner' open={open} onClose={onClose}>
      <img src={funeralHome.image} alt='Image_Funeral_Home' />
      <h4>{funeralHome.name}</h4>
      {funeralHome.address && funeralHome.contactDetails && (
        <>
          <p>
            {funeralHome.address.street} {funeralHome.address.number}
            <br />
            {funeralHome.address.zipCode} {funeralHome.address.city}
            <br />
            T.:{' '}
            <a href={`tel:${funeralHome.contactDetails.phone}`}>
              {funeralHome.contactDetails.phone}
            </a>
            <br />
            E.:{' '}
            <a href={`mailto:${funeralHome.contactDetails.email}`}>
              {funeralHome.contactDetails.email}
            </a>
            <br />
            W.:{' '}
            <a
              href={`${funeralHome.contactDetails.website}`}
              target='_blank'
              rel='noopener noreferrer'>
              {funeralHome.contactDetails.website}
            </a>
          </p>
        </>
      )}
      <div className='product-long-desc' style={{ textAlign: 'left' }}>
        {ReactHtmlParser(funeralHome.description)}
      </div>
    </CustomModal>
  )
}

const DetailContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 15px;
  justify-content: space-around;
  margin: 15px 30px;
  padding: 0;
  ${media.tablet` justify-content: unset; `}
`

const DetailBoxHeader = styled.div`
  margin-bottom: 7.5px;
  p {
    margin: 0;
    font-weight: bold;
    font-size: 18px;
    ${media.phone`font-size: 16px;`}
  }
`
const ContactDetailsContainer = styled.div`
  ${media.largePhone`display: none;`}
`

const DetailLine = styled(ConfiguratorText)`
  line-height: 1.15;
`

// const FuneralHomeInfo = styled.div`
//   display: flex;
//   align-items: baseline;
//   flex-wrap: wrap;
//   margin: 0 30px;
//   margin-bottom: 15px;
//   font-size: 16px;
//   & > * {
//     margin-right: 7.5px;
//   }
//   & > p {
//     margin-bottom: 0;
//     font-size: 18px;
//     font-weight: bold;
//     ${media.phone`font-size: 16px;`}
//   }
//   ${(props) => !props.show && 'display: none;'}
// `
//
// const FuneralHomeName = styled(VerticalAlignWrapper)`
//   cursor: pointer;
//   color: #9abbbf;
//   & > p {
//     font-size: 16px;
//     margin: 0;
//   }
// `
//
// const InlineInfoIcon = styled(MoreInfo)`
//   position: unset;
//   width: 23px;
//   height: 23px;
//   margin: 0 7.5px;
// `



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/ClientDetails.tsx